import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sheduleFilter'
})
export class SheduleFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let newVal = value.slice(0,5);
    return newVal;
  }

}
